import React, { useEffect, useState } from 'react'

const Total = () => {
    const [total, setTotal] = useState("");
    const [count, setCount] = useState(0);
    useEffect(() => { 
        let serveces=localStorage.getItem('serveces');
        let seats=localStorage.getItem('seats');
        let t=0;
         if(serveces){
           serveces=JSON.parse(serveces);
           
           serveces.map((servece)=>{
            t+=servece.price*servece.count
            setCount((prev)=>prev+1)
           })
           
         }
         if(seats){
           seats=JSON.parse(seats);
           
           seats.map((s)=>{
            t+=parseFloat(s.seat.price)
            setCount((prev)=>prev+1)
           })
          
         }
         setTotal(t)
     }, []);
     return {total,count};
}

export default Total